import spacing from '../spacing';
import typography from '../typography';

const getMuiFormControlLabel = () => ({
  styleOverrides: {
    root: {
      marginLeft: 0,
      marginRight: 0,
      marginBottom: spacing(3),
      '&:last-of-type': {
        marginBottom: 0,
      },
    },
    label: {
      ...typography.body2,
      marginLeft: spacing(2),
    },
  },
});
export default getMuiFormControlLabel;
